import { toast } from 'sonner';

export const useToast = () => {
  const showError = (message: string) => {
    toast.error(message, {
      duration: 5000,
    });
  };

  const showSuccess = (message: string) => {
    toast.success(message, {
      duration: 4000,
    });
  };

  const showInfo = (message: string) => {
    toast(message, {
      duration: 4000,
    });
  };

  return {
    showError,
    showSuccess,
    showInfo,
  };
};

export { toast };